export default __webpack_public_path__ + "static/media/next-generation-banner.5434e3ad.jpg";